import { Box, FormControl, FormHelperText, InputLabel, Link, OutlinedInput } from '@mui/material';
import { FC } from 'react';
import { TStep3Props } from './types';

export const Step3: FC<TStep3Props> = ({
	APIKey,
	setAPIKey,
	storeID,
	setStoreID,
	keyID,
	setKeyID,
	storeAddress,
	setStoreAddress,
}) => {
	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					justifyContent: 'space-between',
					width: '100%',
					gap: '20px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'left',
						gap: '20px',
						width: '100%',
					}}
				>
					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel htmlFor="store-address">Store Address</InputLabel>
						<OutlinedInput
							sx={{
								borderRadius: '12px',
							}}
							id="store-address"
							label="Store Address"
							size="small"
							value={storeAddress}
							onChange={(e) => setStoreAddress(e.target.value)}
						/>
						<FormHelperText id="api-key-helper-text">
							your store website address for the customers
						</FormHelperText>
					</FormControl>
					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel htmlFor="api-key">API Token</InputLabel>
						<OutlinedInput
							id="api-key"
							sx={{
								borderRadius: '12px',
							}}
							label="API Token"
							size="small"
							value={APIKey}
							onChange={(e) => setAPIKey(e.target.value)}
						/>
						<FormHelperText id="api-key-helper-text">
							<Link
								href="https://help.easproject.com/using-direct-integration-with-wix-store#step_7"
								target="_blank"
								rel="noreferrer"
								sx={{
									color: '#00000099',
									fontWeight: 'bold',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								step 7
							</Link>
							&nbsp;of the instruction
						</FormHelperText>
					</FormControl>
					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel htmlFor="key-id">Account ID</InputLabel>
						<OutlinedInput
							sx={{
								borderRadius: '12px',
							}}
							label="Account ID"
							size="small"
							id="key-id"
							value={keyID}
							onChange={(e) => setKeyID(e.target.value)}
						/>
						<FormHelperText id="api-key-helper-text">
							<Link
								href="https://help.easproject.com/using-direct-integration-with-wix-store#step_8"
								target="_blank"
								rel="noreferrer"
								sx={{
									color: '#00000099',
									fontWeight: 'bold',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								step 8
							</Link>
							&nbsp;of the instruction
						</FormHelperText>
					</FormControl>

					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel htmlFor="store-id">Store ID</InputLabel>
						<OutlinedInput
							sx={{
								borderRadius: '12px',
							}}
							label="Store ID"
							id="store-id"
							size="small"
							value={storeID}
							onChange={(e) => setStoreID(e.target.value)}
						/>
						<FormHelperText id="api-key-helper-text">
							<Link
								href="https://help.easproject.com/using-direct-integration-with-wix-store#step_10"
								target="_blank"
								rel="noreferrer"
								sx={{
									color: '#00000099',
									fontWeight: 'bold',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								step 10
							</Link>
							&nbsp;of the instruction
						</FormHelperText>
					</FormControl>
				</Box>
				{/* <Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'left',
						gap: '20px',
						width: '100%',
					}}
				>
					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel>Correction Type</InputLabel>
						<Select
							sx={{
								borderRadius: '12px',
							}}
							label="Correction Type"
							value={correctionType ?? ''}
							onChange={(e) => setCorrectionType(e.target.value as 'Add' | 'Deduct')}
						>
							<MenuItem value="Add">Add</MenuItem>
							<MenuItem value="Deduct">Deduct</MenuItem>
						</Select>
					</FormControl>
					<Box>
						<Box>
							<TextField
								sx={{
									width: 'calc(100% - 130px)',
									'& .MuiInputBase-root': {
										borderRadius: '12px',
									},
								}}
								label="VAT Correction Amount"
								variant="outlined"
								type="number"
								size="small"
								value={amount ?? ''}
								onChange={(e) => setAmount(Number(e.target.value))}
							/>
							<FormControl size="small" sx={{ ml: '10px', minWidth: '120px' }}>
								<InputLabel>Currency</InputLabel>
								<Select
									sx={{
										borderRadius: '12px',
									}}
									label="Currency"
									value={selectedCurrency ?? ''}
									onChange={(e) => setSelectedCurrency(e.target.value)}
								>
									{currencies?.rows.map((currency) => (
										<MenuItem key={currency.name} value={currency.name}>
											{currency.name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Box>
						<Box
							sx={{
								fontSize: '.8rem',
								color: '#016193',
								mt: '5px',
								ml: '10px',
								width: '340px',
							}}
						>
							{(exchangeRateEUR || exchangeRateGBP) &&
								yearMonth[0] &&
								yearMonth[1] &&
								selectedCurrency &&
								((platform === VatCorrectionsScheme.NON_EU_IMPORT && selectedCurrency !== 'GBP') ||
									(platform !== VatCorrectionsScheme.NON_EU_IMPORT &&
										selectedCurrency !== 'EUR')) && (
									<Box>
										{platform === VatCorrectionsScheme.NON_EU_IMPORT &&
										exchangeRateGBP?.rows.length === 0 ? (
											<Box sx={{ color: 'error.main' }}>
												No exchange rate for selected currency and reporting period! Please select
												GBP as the currency for the vat correction submission
											</Box>
										) : (platform === VatCorrectionsScheme.IMPORT ||
												platform === VatCorrectionsScheme.NON_UNION ||
												platform === VatCorrectionsScheme.UNION) &&
										  exchangeRateEUR?.rows.length === 0 ? (
											<Box sx={{ color: 'error.main' }}>
												No exchange rate for selected currency and reporting period! Please select
												EUR as the currency for the vat correction submission
											</Box>
										) : (
											<>
												Exchange rate 1 {selectedCurrency} ={' '}
												{platform === VatCorrectionsScheme.NON_EU_IMPORT ? (
													<>{exchangeRateGBP?.rows[0]?.to_gbp_rate} GBP </>
												) : (
													<>{exchangeRateEUR?.rows[0]?.to_eur_rate} EUR</>
												)}{' '}
												will be applied
											</>
										)}
									</Box>
								)}
						</Box>
					</Box>
				</Box> */}
			</Box>
			{/* {!!platform && <Notice platform={platform} />} */}
		</>
	);
};
